import _ from 'lodash'

import React, { useEffect } from 'react'
import { compose } from 'recompose'

import { TIMEZONES } from 'services/supportedTimezones/constants'

import { SelectProps } from 'components/Select/Select'

import { withSupportedTimezonesService, withSupportedTimezonesServiceProps } from 'services/supportedTimezones'

import { Select } from 'components'

import i18n from 'translations'

import withInfiniteDropdownHelpers, {
  withInfiniteDropdownHelpersProps,
} from '../../legacy/InfiniteDropdowns/withInfiniteDropdown'
import { DropdownProps } from '../InfiniteDropdownsModel'

export type SupportedTimezonesDropdownProps = withInfiniteDropdownHelpersProps
  & withSupportedTimezonesServiceProps
  & SelectProps
  & DropdownProps

const SupportedTimezonesDropdown: React.FC<SupportedTimezonesDropdownProps> = ({
  disabled,
  infiniteDropdownHelpers,
  infiniteDropdownState,
  onChange,
  placeholder,
  value,
  ...rest
}) => {
  const { cacheUniq, options } = infiniteDropdownState

  useEffect(() => {
    infiniteDropdownHelpers.handleLoadMoreElementsOnSuccess({
      newPage: 1,
      response: {
        data: _.orderBy(_.reduce(TIMEZONES, (result, name, id) => [
          ...result,
          {
            id,
            name,
          },
        ], []), 'name'),
      },
      result: {},
    })

    if (value) {
      const element = {
        id: value,
        name: TIMEZONES[value as string],
      }

      infiniteDropdownHelpers.handleComponentDidMountOnSuccess({ data: element })
    }
  }, [])

  const handleChange = (e) => {
    infiniteDropdownHelpers.handleOnChange(e, () => onChange(e))
  }

  return (
    <Select
      {...rest}
      cacheUniq={cacheUniq}
      disabled={disabled}
      options={_.orderBy(options, ({ frequent }) => frequent)}
      placeholder={placeholder || i18n.t('components:InfiniteDropdowns:SupportedTimezones:placeholder')}
      value={value}
      searchable
      onChange={handleChange}
    />
  )
}

const enhance = compose(
  withSupportedTimezonesService,
  withInfiniteDropdownHelpers,
)

export default enhance(SupportedTimezonesDropdown)
